export default __webpack_public_path__ + "static/media/022-triceratops.1d7660e3.svg";